
import bookclosuretablecss from "../css/bookclosuretable.module.css";


const BookClosureTable = ({ tableHeaders, rowData, columnClasses, headerClasses }) => {
    return (
        <div className={bookclosuretablecss.bookClosureTableContainer}>
            <table className={bookclosuretablecss.bookClosureTable}>
                <thead>
                    <tr>
                        {Object.entries(tableHeaders).map(([key, label]) => {
                            const headerClass = headerClasses[key] || "";

                            return (
                                <th key={key} className={bookclosuretablecss[headerClass]}>
                                    {label}
                                </th>
                            );
                        })}
                    </tr>
                </thead>
                <tbody>
                    {rowData.map((row, rowIndex) => (
                        <tr key={rowIndex}>
                            {Object.entries(row).map(([key, value], cellIndex) => {

                                const cellClass = columnClasses[key] || "";

                                return (
                                    <td key={cellIndex} className={bookclosuretablecss[cellClass]}>
                                        {Array.isArray(value) ? (
                                            value.map((user, i) => (
                                                <span key={i} className="user-avatar">
                                                    &ensp;{user}
                                                </span>
                                            ))
                                        ) : (
                                            value
                                        )}
                                    </td>
                                );
                            })}
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    );
};

export default BookClosureTable;
